export default __webpack_public_path__ + "static/media/icon-hint.1458d991.svg";